export enum UnitOfMeasurementEnum {
  alunoMes = 1,
  alunoAno = 2,
  km = 3,
  m2 = 4,
  professorMes = 5,
  refeicaoMes = 6,
  projeto = 7
}
